import 'react';
import '../Accordion/styles.js';
import { getColorAlias } from '../../utils/index.js';
import '../Breadcrumb/styles.js';
import '../Button/index.js';
import '../Card/index.js';
import '../Field/checkbox/Checkbox.js';
import '../Field/styles.js';
import '../Field/checkbox/CheckboxInput.js';
import '../Spinner/styles.js';
import '../Chip/styles.js';
import '../ColorList/index.js';
import '../Uploader/styles.js';
import '../IconButton/styles.js';
import '../ListItem/styles.js';
import '../ListItem/components/ListItemPrefix/styles.js';
import '../ListItem/components/ListItemContent/styles.js';
import '../ListItem/components/ListItemSuffix/styles.js';
import './styles.js';
import 'react-dom';
import '../Modal/styles.js';
import '../PIEThemeProvider/index.js';
import '../Field/radioButton/RadioButton.js';
import '../Field/radioButton/Radio.js';
import 'react-popper';
import '../Field/dropdown/styles.js';
import '../Field/searchableDropdown/styles.js';
import '../Tag/styles.js';
import 'styled-components';
import '../Field/textArea/styles.js';
import '../Field/textField/TextField.js';
import '../Toggle/styles.js';
import '../Tooltip/styles.js';
import '../Table/styles.js';
import '../DatePicker/components/actionButtons/styles.js';
import '../DatePicker/components/day/styles.js';
import '../DatePicker/components/dayNameRow/styles.js';
import '../DatePicker/components/calendar/styles.js';
import '../DatePicker/components/selectors/styles.js';
import '../DatePicker/components/datePickerSelect/styles.js';
import '../DatePicker/components/header/styles.js';
import '../DatePicker/components/datePickerNarrow/styles.js';
import '../DatePicker/styles.js';
import '../DateView/styles.js';
import '../DateView/components/calendarView/styles.js';
import '../SideSheet/styles.js';
import '../Skeleton/styles.js';
import '../Tabs/styles.js';
import '../ProgressBar/styles.js';
import '../SegmentedControl/styles.js';
import '../SegmentedControl/components/segment/styles.js';
import '../Slider/styles.js';
import '../Messaging/styles.js';
import '../Messaging/Toast/styles.js';
import '../Messaging/MessageProvider/index.js';

const getLinkColor = (variant) => {
    switch (variant) {
        case 'default':
            return getColorAlias('contentLink');
        case 'high-visibility':
            return getColorAlias('contentLinkDistinct');
        case 'inversion':
            return getColorAlias('contentLinkInverse');
        default:
            console.warn('Error, incorrect props. Pass the correct set of props to the getLinkColor function.');
    }
};

export { getLinkColor };
